import React, { useEffect, useState } from "react";
import apiService from '../../../services/apiService';
import Loader from '../../layouts/loader';
import CustomToast from '../../Toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import "./carousel.css";

const Carousel = ({ moduleContent, updateLmsModule }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [loader, setLoader] = useState(false);
  const [viewedSlides, setViewedSlides] = useState(new Set([0])); 
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLang = localStorage.getItem('userLang')

  const slides = Array.isArray(moduleContent?.moduleContent?.carousal_url) && moduleContent?.moduleContent?.carousal_url.length > 0
    ? moduleContent?.moduleContent?.carousal_url.map((url, index) => ({
      id: index + 1,
      image: url,
    }))
    : [{
      id: 1,
      image: "/images/no-image-found.png",
    }];


  const getLangCode = (lang) => {
    switch (lang) {
      case 'English':
        return 'en';
      case 'Hindi':
        return 'hi';
      case 'Marathi':
        return 'mar';
      default:
        return 'en';
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Reset active index and viewed slides when moduleContent changes
    setActiveIndex(0);
    setViewedSlides(new Set([0])); // Reset to only first slide viewed
  }, [moduleContent]);


  useEffect(() => {
    import("bootstrap").then(({ Carousel }) => {
      const carouselElement = document.getElementById("inclusionalCarousel");
      if (carouselElement) {
        // Dispose existing carousel instance if it exists
        const existingCarousel = Carousel.getInstance(carouselElement);
        if (existingCarousel) {
          existingCarousel.dispose();
        }

        const carousel = new Carousel(carouselElement, {
          //interval: 5000,
          interval: false,
          wrap: true,
        });
        carouselElement.addEventListener("slide.bs.carousel", (event) => {
          setActiveIndex(event.to);
          // Track viewed slides
          setViewedSlides(prev => new Set([...prev, event.to]));
        });
      }
    });
    console.log("moduleContent", moduleContent?.moduleContent?.carousal_url);
  }, [moduleContent?.moduleContent?.carousal_url]);

  const handleIndicatorClick = (index) => {
    const carouselElement = document.getElementById("inclusionalCarousel");
    if (carouselElement) {
      import("bootstrap").then(({ Carousel }) => {
        const bsCarousel = Carousel.getInstance(carouselElement);
        if (bsCarousel) {
          bsCarousel.to(index);
          // Track viewed slides when clicking indicators
          setViewedSlides(prev => new Set([...prev, index]));
        }
      });
    }
  };

  // Check if all slides have been viewed
  const allSlidesViewed = viewedSlides.size === slides.length;

  const handleMarkAsCompleted = async (data) => {
    updateLmsModule().then((data) => {
    });
    setCompleted(true);
  };

  return (
    <>
      <div className="carousel-container">
        <div className="text-center mt-4"><div dangerouslySetInnerHTML={{ __html: moduleContent?.moduleContent?.content }} /></div>
        <div
          id="inclusionalCarousel"
          className="carousel slide"
         // data-bs-ride="carousel"
        >
          <div className="carousel-inner px-5 py-4">
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`carousel-item ${index === activeIndex ? "active" : ""
                  }`}
              >
                <img
                  src={slide.image}
                  className="d-block w-100"
                  alt={`Slide ${slide.id}`}
                />
              </div>
            ))}
          </div>
          {slides?.length > 1 && ( <>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#inclusionalCarousel"
            data-bs-slide="prev"
            disabled={activeIndex === 0}
            style={{ 
              opacity: activeIndex === 0 ? 0.3 : 1,
              cursor: activeIndex === 0 ? 'not-allowed' : 'pointer',
              pointerEvents: activeIndex === 0 ? 'none' : 'auto'
            }}
          >
            <img
              src="/images/left-arrow.svg"
              alt="Previous"
              className="custom-arrow"
            />
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#inclusionalCarousel"
            data-bs-slide="next"
            disabled={activeIndex === slides.length - 1}
            style={{ 
              opacity: activeIndex === slides.length - 1 ? 0.3 : 1,
              cursor: activeIndex === slides.length - 1 ? 'not-allowed' : 'pointer',
              pointerEvents: activeIndex === slides.length - 1 ? 'none' : 'auto'
            }}
          >
            <img
              src="/images/right-arrow.svg"
              alt="Next"
              className="custom-arrow"
            />
          </button>
          </>)}
        </div>
        {slides?.length > 1 && (
        <div className="custom-indicators p-4">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              className={`indicator ${index === activeIndex ? "active" : ""}`}
              onClick={() => handleIndicatorClick(index)}
              aria-label={`Slide ${slide.id}`}
            ></button>
          ))}
        </div>
        )}
      </div>
      <p className='text-end mt-4 pt-3 mb-0 border-top'>
        {!moduleContent?.moduleContent?.is_completed && (
          <button 
            onClick={handleMarkAsCompleted} 
            className='btn btn-md btn-primary rounded-pill mt-1'
            disabled={!allSlidesViewed}
            style={{ opacity: allSlidesViewed ? 1 : 0.6, cursor: allSlidesViewed ? 'pointer' : 'not-allowed' }}
          >
            {tForLang('course_modules_next')}
          </button>
        )}
        {moduleContent?.moduleContent?.is_completed && (
          <button onClick={handleMarkAsCompleted} className='btn btn-md btn-primary rounded-pill mt-1'>{tForLang('course_modules_next')}</button>
        )}
      </p>
    </>
  );
};

export default Carousel;
